module.exports = __webpack_public_path__ + "static/media/question-circle.4889b070.svg";